<template>
    <v-card-text>
        <h3>Configuração de cotas disponíveis para venda</h3>
        <v-form ref="formConfigCotasDisponiveis">
            <v-row style="margin-top: 25px" class="d-flex align-center">
                <v-col cols="12" md="4">
                    <MoneyTextField
                            label="Percentual de cotas disponíveis:"
                            class="required"
                            :disabled="!localLimiteCotasFluxoComumAtivo"
                            outlined
                            maxlength="3"
                            v-model="localLimiteCotasFluxoComum"
                            :rules="[$rules.required,(value) => value > 0 ? true : 'O valor deve ser maior que 0']"
                            :options="{locale: 'pt-BR',suffix: '%',precision: 0,prefix: ''}"
                            maxvalue="100" />
                </v-col>
                <v-col cols="12" md="6" class="mt-5">
                    <v-switch class="px-0"
                              fluid v-model="localLimiteCotasFluxoComumAtivo" label="Habilitar/Desabilitar"></v-switch>
                </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="salvarConfiguracao">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-card-text>
</template>

<script>
  import { AlertTypes } from '../../plugins/alerts_types'
  import { notification } from '../../plugins/helpers'

  export default {
    name: 'ConfiguracaoLimiteCotasReserva',
    props: {
      limiteCotasFluxoComumAtivo: {
        type: Boolean,
        default: false
      },
      limiteCotasFluxoComum: {
        type: [Number, String],
        default: 1
      }
    },
    data () {
      return {
        localLimiteCotasFluxoComumAtivo: this.limiteCotasFluxoComumAtivo,
        localLimiteCotasFluxoComum: this.limiteCotasFluxoComum
      }
    },
    watch: {
      localLimiteCotasFluxoComumAtivo (newValue) {
        this.$emit('update:limiteCotasFluxoComumAtivo', newValue)
      },
      localLimiteCotasFluxoComum (newValue) {
        this.$emit('update:limiteCotasFluxoComum', newValue)
      },
      limiteCotasFluxoComumAtivo (newValue) {
        this.localLimiteCotasFluxoComumAtivo = newValue
      },
      limiteCotasFluxoComum (newValue) {
        this.localLimiteCotasFluxoComum = newValue
      }
    },
    methods: {
      async salvarConfiguracao () {
        if (!this.$refs.formConfigCotasDisponiveis.validate()) {
          return
        }
        try {
          await this.$http.put('/painel/percentual_cotas_disponiveis', {
            percentual_cotas_disponiveis_ativo: this.localLimiteCotasFluxoComumAtivo,
            percentual_cotas_disponiveis: +this.localLimiteCotasFluxoComum
          })
          notification(AlertTypes.SUCCESS, 'Percentual de cotas disponíveis atualizado com sucesso!')
        } catch (e) {
          notification(AlertTypes.ERROR, 'Não foi possível atualizar o percentual de cotas disponíveis no momento, tente novamente e se o problema persistir, entre em contato com a Área de Suporte.')
        }
      }
    }
  }
</script>

<style scoped>
/* Adicione qualquer estilo necessário aqui */
</style>
